module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headertoc01",
      "epub:type": "toc",
      "id": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', {
    attrs: {
      "id": "headertoc01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vi",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vii",
      "id": "pvii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rintro"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0008#intro"
    }
  }, [_vm._v("Introduction: “The Girl in the Portrait”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rahintro01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0008#ahintro01"
    }
  }, [_vm._v("Interpreting Star Images and Subjectivities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rahintro02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0008#ahintro02"
    }
  }, [_vm._v("Hollywood and the U.S. Home Front in the 1940s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rahintro03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0008#ahintro03"
    }
  }, [_vm._v("Gene Tierney’s Star Buildup and Her “First Modern Role”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0009#ch01"
    }
  }, [_vm._v("1. Working It: Beautification and War Effort")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0101"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0009#ah0101"
    }
  }, [_vm._v("Gene Tierney Goes to War: "), _c('i', [_vm._v("Thunder Birds")]), _vm._v(" and "), _c('i', [_vm._v("China Girl")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0102"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0009#ah0102"
    }
  }, [_vm._v("Office Politics: The Making of "), _c('i', [_vm._v("Laura")]), _vm._v(" and Tierney’s Image Makeover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0103"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0009#ah0103"
    }
  }, [_c('i', [_vm._v("Laura")]), _vm._v(" as War(drobe) Film: Bonnie Cashin’s Costumes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0104"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0009#ah0104"
    }
  }, [_vm._v("Coda: "), _c('i', [_vm._v("A Bell for Adano")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0010#ch02"
    }
  }, [_vm._v("2. Women on the Edge: Demobilization and Domesticity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0201"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0010#ah0201"
    }
  }, [_vm._v("The Dark Side of the Moon: "), _c('i', [_vm._v("Leave Her to Heaven")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0202"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0010#ah0202"
    }
  }, [_vm._v("Gene & Ty: "), _c('i', [_vm._v("The Razor’s Edge")]), _vm._v(" and "), _c('i', [_vm._v("That Wonderful Urge")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0011#ch03"
    }
  }, [_vm._v("3. The Front Lines of Life and Death: Motherhood and Mortality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0301"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0011#ah0301"
    }
  }, [_vm._v("Boom Years: The U.S. Maternal Ideal and Gene Tierney as Star Mother")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0302"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0011#ah0302"
    }
  }, [_vm._v("The Redemptive Maternal: "), _c('i', [_vm._v("Heaven Can Wait")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0303"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0011#ah0303"
    }
  }, [_vm._v("Maternal Plentitude: "), _c('i', [_vm._v("Dragonwyck")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0304"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0011#ah0304"
    }
  }, [_vm._v("The Resisting Maternal: "), _c('i', [_vm._v("The Ghost and Mrs. Muir")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch04"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "viii",
      "id": "pviii",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0012#ch04"
    }
  }, [_vm._v("4. Into the Whirlpool: Psychological Disorder and Rehabilitation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0401"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0012#ah0401"
    }
  }, [_vm._v("Gene Tierney Reframed: Publicity and Press Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0402"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0012#ah0402"
    }
  }, [_vm._v("Playacting and Sleepwalking: "), _c('i', [_vm._v("Whirlpool")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rconc"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0013#conc"
    }
  }, [_vm._v("Conclusion: The Reproducible Gene Tierney")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf",
    attrs: {
      "id": "racknow"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0014#acknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "rnotes"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0015#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "rch05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0016#ch05"
    }
  }, [_vm._v("Gene Tierney’s Credits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rahaft0501"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0016#ahaft0501"
    }
  }, [_vm._v("Film")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0501"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0016#ah0501"
    }
  }, [_vm._v("Television")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "rsel_bib"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0017#sel_bib"
    }
  }, [_vm._v("Selected Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "rindex"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuscheibel0018#index"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c804a7e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsu-scheibel-0007.vue
// module id = 72
// module chunks = 0